module.exports = __webpack_public_path__ + "static/media/juras.c2b512eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/juras.jpg
// module id = 554
// module chunks = 0